module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_isString.js
// module id = 1392
// module chunks = 0